export default "__VITE_ASSET__CnWAkgWg__"